import { useMemo, useCallback } from 'react';
import '../../utils/responsive.es.js';
import 'body-scroll-lock';
import '../../hooks/useNotification/useNotification.es.js';
import '../../hooks/useToast/useToast.es.js';
import '@popperjs/core';
import '../../utils/assertions.es.js';
import '../../utils/scrollIntoView.es.js';
import 'polished';
import '@styled-system/css';
import 'styled-components';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import 'react-beautiful-dnd';
import 'use-callback-ref';
import { useControlled } from '../../hooks/useControlled/useControlled.es.js';
import 'nanoid/non-secure';
import { getPositionFromValue, getValueFromPosition } from './helpers.es.js';

var useSlider = function useSlider(props) {
  var min = props.min,
      max = props.max,
      _props$width = props.width,
      width = _props$width === void 0 ? 300 : _props$width,
      onChange = props.onChange,
      onChangeEnd = props.onChangeEnd,
      defaultValue = props.defaultValue,
      value = props.value;

  var _useControlled = useControlled({
    defaultValue: defaultValue != null ? defaultValue : {
      min: min,
      max: max
    },
    value: value,
    onChange: onChange
  }),
      currentValue = _useControlled[0],
      updateValue = _useControlled[1];

  var positions = useMemo(function () {
    var _a, _b;

    return {
      min: getPositionFromValue((_a = currentValue == null ? void 0 : currentValue.min) != null ? _a : min, min, max, width),
      max: getPositionFromValue((_b = currentValue == null ? void 0 : currentValue.max) != null ? _b : max, min, max, width)
    };
  }, [currentValue, min, max, width]);
  var updateMinFromPosition = useCallback(function (position) {
    var _a;

    var minPosition2 = getValueFromPosition(position, min, max, width);
    updateValue({
      min: minPosition2,
      max: (_a = currentValue == null ? void 0 : currentValue.max) != null ? _a : max
    });
  }, [min, max, currentValue, updateValue, width]);
  var updateMaxFromPosition = useCallback(function (position) {
    var _a;

    var maxPosition2 = getValueFromPosition(position, min, max, width);
    updateValue({
      min: (_a = currentValue == null ? void 0 : currentValue.min) != null ? _a : min,
      max: maxPosition2
    });
  }, [min, max, currentValue, updateValue, width]);
  var onMinChangeEnd = useCallback(function (position) {
    var _a;

    onChangeEnd == null ? void 0 : onChangeEnd({
      min: getValueFromPosition(position, min, max, width),
      max: (_a = currentValue == null ? void 0 : currentValue.max) != null ? _a : max
    });
  }, [currentValue, min, max, width, onChangeEnd]);
  var onMaxChangeEnd = useCallback(function (position) {
    var _a;

    onChangeEnd == null ? void 0 : onChangeEnd({
      min: (_a = currentValue == null ? void 0 : currentValue.min) != null ? _a : min,
      max: getValueFromPosition(position, min, max, width)
    });
  }, [currentValue, min, max, width, onChangeEnd]);
  var minPosition = useMemo(function () {
    return getPositionFromValue(min, min, max, width);
  }, [min, max, width]);
  var maxPosition = useMemo(function () {
    return getPositionFromValue(max, min, max, width);
  }, [min, max, width]);
  return {
    positions: positions,
    minPosition: minPosition,
    maxPosition: maxPosition,
    updateMinFromPosition: updateMinFromPosition,
    updateMaxFromPosition: updateMaxFromPosition,
    onMinChangeEnd: onMinChangeEnd,
    onMaxChangeEnd: onMaxChangeEnd
  };
};

export { useSlider };